export default __webpack_public_path__ + "static/media/263-italy.ab0bd5d4.svg";